<template>
    <div>
        <div class="exit">
            <div>
                <div>
                    <span>头像</span>
                </div>
                <div class="portrait">
                    <img src="../assets/pic.png" alt="">
                    <span class="iconfont icon-xiangyou-copy"></span>
                </div>
            </div>
            <div>
                <div>
                    <span>手机号</span>
                </div>
                <div>
                    <span>{{mobile}}</span>
                    <span class="iconfont icon-xiangyou-copy"></span>
                </div>
            </div>
            <div @click="goWalletLog()">
                <div>
                    <span>积分余额</span>
                </div>
                <div>
                    <span>{{ point }}</span>
                    <span class="iconfont icon-xiangyou-copy"></span>
                </div>
            </div>
          <!--
            <div @click="goPay()">
                <div>
                    <span>支付</span>
                </div>
                <div>
                    <span></span>
                    <span class="iconfont icon-xiangyou-copy"></span>
                </div>
            </div>
          -->
            <div class="exitbt" @click="exit">
                <span>退出当前账号</span>
            </div>
        </div>
        <tabbar :selected="selected"></tabbar>
    </div>
</template>

<script>
    import common from "../common";
    import tabbar from '@/components/tabbar'
    import {Indicator} from "mint-ui";

    export default {
        name: 'exit',
        components: {tabbar},
        data() {
            return {
                selected: "my",
                mobile: "",
                point: 0,
                token: ""
            }
        },
        methods: {
            getWallet() {
                let querystring = require('querystring');
                this.$api.post("/wx/user/wallet",
                    querystring.stringify({
                        token: this.token,
                    })
                ).then(data => {
                    if (data.data.status == 1) {
                        this.point = data.data.data.point_balance;
                    } else {

                    }
                }).catch(err => {
                    console.log(err);
                });
            },
            goWalletLog()
            {
                this.$router.push("wallet_log");
            },
            goPay()
            {
                this.$router.push("/container-yard/pay");
            },
            exit() {
                common.deletelocalStorage("userInfo");
                common.clearCookie();
                this.$router.push("login");
            }
        },
        created() {
            //判断cookie中是否存在token
            let ifcookietoken = document.cookie.indexOf("token=") != -1;
            if (!!JSON.parse(common.getlocalStorage("userInfo"))) {
                this.mobile = JSON.parse(common.getlocalStorage("userInfo")).mobile;
            } else if (ifcookietoken) {
                this.mobile = common.getCookie("mobile");
            } else {
                this.$router.replace({name: 'login'});
            }
        },
        mounted() {
            //判断cookie中是否存在token
            let ifcookietoken = document.cookie.indexOf("token=") != -1;
            if (!!JSON.parse(common.getlocalStorage("userInfo"))) {
                this.token = JSON.parse(common.getlocalStorage("userInfo")).token;
            } else if (ifcookietoken) {
                this.token = common.getCookie("token");
            } else {
                this.$router.replace({name: 'login'});
            }
            this.getWallet();
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .exit {
        padding-top: 1vh;
    }

    .exit > div {
        margin: 0 auto;
        width: 90vw;
        height: 8vh;
        padding: 1vh 0;
        display: -webkit-flex;
        border-bottom: 1px solid #e7e7e7;
        justify-content: space-between;
        align-items: center;
        color: #999999;
        font-size: 0.4rem;
    }

    .exit img {
        width: 12vw;
        margin-right: 3vw;
    }

    .portrait {
        display: -webkit-flex;
        align-items: center;
    }

    .exit > .exitbt {
        width: 60vw;
        margin: 10vh auto;
        height: 6vh;
        background: #0097fe;
        border-radius: 10px;
        color: white;
        justify-content: center;
    }
</style>
      


// WEBPACK FOOTER //
// src/components/exit.vue